import { useState, useEffect } from 'react';
function MainApp() {
    return(
        <>
            <div className="progress-bar"></div>
           { /**================= HEADER ================= */}
            <header className="header">
                <div className="container">
                    <div className="logo">
                        <h2>Wedding Wishes</h2>
                        <span>Invitations That Tell Your Story</span>
                    </div>
                    <nav>
                        <ul className="nav-links">
                            <li><a href="#">Home</a></li>
                            <li><a href="#">Collections</a></li>
                            <li><a href="#">Video Invitations</a></li>
                            <li><a href="#">About</a></li>
                            <li><a href="#">Reviews</a></li>
                            <li><a href="#">Blog</a></li>
                            <li><a href="#">Contact</a></li>
                        </ul>
                    </nav>
                    <a href="#" className="btn">Create Invitation</a>
                    <div className="menu-btn">
                        <i className="fa-solid fa-bars"></i>
                    </div>
                </div>
            </header>
            { /**================= HERO ================= */}
            <section className="hero">
                <div className="parallax"></div>
                <div className="container hero-grid">
                    <div className="hero-content">
                        <h4>Crafting Beautiful</h4>
                        <h1>Wedding Invitations</h1>
                        <h2>That Tell Your Story</h2>
                        <p>
                            From elegant digital invitations to premium printed cards,
                            we create unforgettable wedding experiences with
                            stunning personalized designs.
                        </p>
                        <div className="hero-buttons">
                            <a href="#" className="btn">Explore Collection</a>
                            <a href="#" className="btn-outline">
                                Create Invitation
                            </a>
                        </div>
                        <div className="trusted">
                            <div className="avatars">
                                <img src="assets/images/user1.jpg" />
                                <img src="assets/images/user2.jpg" />
                                <img src="assets/images/user3.jpg" />
                            </div>
                            <div>
                                ★★★★★
                                <p>Trusted by 10,000+ Couples</p>
                            </div>
                        </div>
                    </div>
                    <div className="hero-image">
                        <img src="assets/images/hero/hero.png" alt="Wedding Invitation" />
                    </div>
                </div>
            </section>
        { /**================= STATS ================= */}
            <section className="stats">
                <div className="container">
                    <div className="stat">
                        <i className="fa-solid fa-users"></i>
                        <h3 data-count="10000">0</h3>
                        <p>Happy Users</p>
                    </div>
                    <div className="stat">
                        <i className="fa-solid fa-layer-group"></i>
                        <h3 data-count="500">0</h3>
                        <p>Premium Templates</p>
                    </div>
                    <div className="stat">
                        <i className="fa-solid fa-video"></i>
                        <h3>500+</h3>
                        <p>Video Invitations</p>
                    </div>
                    <div className="stat">
                        <i className="fa-solid fa-mobile-screen-button"></i>
                        <h3>1000+</h3>
                        <p>WhatsApp Invites</p>
                    </div>
                    <div className="stat">
                        <i className="fa-solid fa-pencil-square"></i>
                        <h3>500+</h3>
                        <p>Wedding Satinary</p>
                    </div>
                    <div className="stat">
                        <i className="fa-solid fa-globe"></i>
                        <h3>30+</h3>
                        <p> Web Wedding Invite</p>
                    </div>
                    <div className="stat">
                        <i className="fa-solid fa-envelope"></i>
                        <h3>1000+</h3>
                        <p>Enevelop Design</p>
                    </div>
                </div>
            </section>
        { /**================= VIDEO SECTION =================  */}
            <section className="categories">
                <div className="container">
                    <div className="section-title">
                        <h2>Browse By Category</h2>
                        <p>Find the perfect invitation for every wedding function.</p>
                    </div>
                    <div className="category-grid">
                        <div className="cat">
                            <i className="fa-solid fa-calendar"></i>
                            <span>Save the Date</span>
                        </div>
                        <div className="cat">
                            <i className="fa-solid fa-heart"></i>
                            <span>Engagement</span>
                        </div>
                        <div className="cat">
                            <i className="fa-solid fa-ring"></i>
                            <span>Wedding</span>
                        </div>
                        <div className="cat">
                            <i className="fa-solid fa-champagne-glasses"></i>
                            <span>Reception</span>
                        </div>
                        <div className="cat">
                            <i className="fa-solid fa-home"></i>
                            <span>House Warming</span>
                        </div>
                        <div className="cat">
                            <i className="fa-solid fa-cake"></i>
                            <span>Birthday</span>
                        </div>
                        <div className="cat">
                            <i className="fa-solid fa-baby"></i>
                            <span>Baby Shower</span>
                        </div>
                        <div className="cat">
                            <i className="fa-solid fa-ellipsis"></i>
                            <span>More</span>
                        </div>
                    </div>
                </div>
            </section>
            {/** ================= VIDEO SECTION ================= */}
            <section className="video-section">
                <div className="container video-grid">
                    <div className="video-content">
                        <h4>Made With Love</h4>
                        <h2>Video Invitations</h2>
                        <h3>Make Your Invite Come Alive</h3>
                        <p>
                            Engage your guests with cinematic wedding invitation
                            videos beautifully animated and emotionally connected.
                        </p>
                        <a href="#" className="btn">
                            View Video Invitations
                        </a>
                    </div>
                    <div className="video-box">
                        <img src="assets/images/video-thumbnail.jpg" />
                        <div className="play">
                            <i className="fa-solid fa-play"></i>
                        </div>
                    </div>
                </div>
            </section>
            {/**================= FEATURED INVITATIONS =================*/}

            <section className="featured">
                <div className="container">
                    <div className="section-title">
                        <h2>Featured Invitation Designs</h2>
                        <p>Premium designs crafted for your special moments.</p>
                    </div>
                    <div className="card-slider">
                        <div className="invite-card">
                            <img src="assets/images/cards/card1.jpg" alt="Invitation" />
                            <div className="card-content">
                                <h3>Floral Dream</h3>
                                {/* <!-- <span>₹299</span> --> */}
                                <a href="#" className="small-btn">View Design</a>
                            </div>
                        </div>
                        <div className="invite-card">
                            <img src="assets/images/cards/card2.jpg" />
                            <div className="card-content">
                                <h3>Pastel Elegance</h3>
                                {/* <!-- <span>₹299</span> --> */}
                                <a href="#" className="small-btn">View Design</a>
                            </div>
                        </div>
                        <div className="invite-card">
                            <img src="assets/images/cards/card3.jpg" />
                            <div className="card-content">
                                <h3>Botanical Bliss</h3>
                                {/* <!-- <span>₹299</span> --> */}
                                <a href="#" className="small-btn">View Design</a>
                            </div>
                        </div>
                        <div className="invite-card">
                            <img src="assets/images/cards/card4.jpg" />
                            <div className="card-content">
                                <h3>Minimal Luxe</h3>
                                {/* <!-- <span>₹299</span> --> */}
                                <a href="#" className="small-btn">View Design</a>
                            </div>
                        </div>
                        <div className="invite-card">
                            <img src="assets/images/cards/card5.jpg" />
                            <div className="card-content">
                                <h3>Lavender Grace</h3>
                                {/* <!-- <span>₹299</span> --> */}
                                <a href="#" className="small-btn">View Design</a>
                            </div>
                        </div>
                    </div>
                    <div className="center-btn">
                        <a href="#" className="btn">View All Designs</a>
                    </div>
                </div>
            </section>
        { /**================= HOW IT WORKS =================*/}
            <section className="how-it-works">
                <div className="container">
                    <div className="section-title">
                        <h2>How It Works</h2>
                        <p>Create your invitation in five simple steps.</p>
                    </div>
                    <div className="steps">
                        <div className="step">
                            <div className="icon">
                                <i className="fa-solid fa-image"></i>
                            </div>
                            <h3>Choose Design</h3>
                            <p>Select your favourite invitation template.</p>
                        </div>
                        <div className="step">
                            <div className="icon">
                                <i className="fa-solid fa-pen"></i>
                            </div>
                            <h3>Customize</h3>
                            <p>Add names, venue, events and photos.</p>
                        </div>
                        <div className="step">
                            <div className="icon">
                                <i className="fa-solid fa-eye"></i>
                            </div>
                            <h3>Preview</h3>
                            <p>Review every detail before finalizing.</p>
                        </div>
                        <div className="step">
                            <div className="icon">
                                <i className="fa-solid fa-cloud-arrow-down"></i>
                            </div>
                            <h3>Download</h3>
                            <p>Receive HD digital invitation instantly.</p>
                        </div>
                        <div className="step">
                            <div className="icon">
                                <i className="fa-solid fa-truck-fast"></i>
                            </div>
                            <h3>Print</h3>
                            <p>Premium printed cards delivered to your doorstep.</p>
                        </div>
                    </div>
                </div>
            </section>
            { /**================= WHY CHOOSE US =================*/}
            <section className="why-us">
                <div className="container">
                    <div className="section-title">
                        <h2>Why Choose Wedding Wishes?</h2>
                        <p>Thousands of couples trust us every year.</p>
                    </div>
                    <div className="why-grid">
                        <div className="why-box">
                            <i className="fa-solid fa-sliders"></i>
                            <h3>100% Customizable</h3>
                            <p>Create a unique invitation matching your wedding theme.</p>
                        </div>
                        <div className="why-box">
                            <i className="fa-solid fa-gem"></i>
                            <h3>Premium Designs</h3>
                            <p>Professionally designed luxury invitation collection.</p>
                        </div>
                        <div className="why-box">
                            <i className="fa-solid fa-clock"></i>
                            <h3>On-Time Delivery</h3>
                            <p>Fast digital delivery and reliable printing service.</p>
                        </div>
                        <div className="why-box">
                            <i className="fa-solid fa-headset"></i>
                            <h3>24/7 Support</h3>
                            <p>Dedicated customer support whenever you need help.</p>
                        </div>
                        <div className="why-box">
                            <i className="fa-solid fa-shield-heart"></i>
                            <h3>100% Satisfaction</h3>
                            <p>Your happiness is our biggest priority.</p>
                        </div>
                    </div>
                </div>
            </section>
            {/**================= TESTIMONIALS ================= */}
            <section className="testimonials">
                <div className="container">
                    <div className="section-title">
                        <h2>What Our Couples Say</h2>
                        <p>Real stories from happy customers.</p>
                    </div>
                    <div className="testimonial-slider">
                        <div className="testimonial">
                            <p>
                                "The invitation looked absolutely beautiful.
                                Everyone appreciated the premium quality."
                            </p>
                            <div className="user">
                                <img src="assets/images/testimonials/user1.jpg" />
                                <div>
                                    <h4>Riya & Karan</h4>
                                    ★★★★★
                                </div>
                            </div>
                        </div>
                        <div className="testimonial">
                            <p>
                                "Fantastic support team and amazing video invitation.
                                Highly recommended."
                            </p>
                            <div className="user">
                                <img src="assets/images/testimonials/user2.jpg" />
                                <div>
                                    <h4>Pooja & Vivek</h4>
                                    ★★★★★
                                </div>
                            </div>
                        </div>
                        <div className="testimonial">
                            <p>
                                "Our guests loved the invitation website.
                                Beautiful animation and fast delivery."
                            </p>
                            <div className="user">
                                <img src="assets/images/testimonials/user3.jpg" />
                                <div>
                                    <h4>Neha & Aditya</h4>
                                    ★★★★★
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        {/**================= NEWSLETTER ================= */}
            <section className="newsletter">
                <div className="container newsletter-box">
                    <div>
                        <h2>
                            Let's Create Something Beautiful Together
                        </h2>
                        <p>
                            Join thousands of couples who trusted us
                            for their special day.
                        </p>
                    </div>
                    <form>
                        <input type="email" placeholder="Enter your email address" />
                        <button className="btn">
                            Get Started
                        </button>
                    </form>
                </div>
            </section>
            <footer>
                <div className="container footer-grid">
                    <div>
                        <h3>Wedding Wishes</h3>
                        <p>
                            We create elegant wedding invitations,
                            video invitations and premium printed cards.
                        </p>
                        <div className="social">
                            <a href="#"><i className="fab fa-facebook-f"></i></a>
                            <a href="#"><i className="fab fa-instagram"></i></a>
                            <a href="#"><i className="fab fa-pinterest-p"></i></a>
                            <a href="#"><i className="fab fa-youtube"></i></a>
                        </div>
                    </div>
                    <div>
                        <h4>Quick Links</h4>
                        <ul>
                            <li><a href="#">Home</a></li>
                            <li><a href="#">Collections</a></li>
                            <li><a href="#">Video Invitations</a></li>
                            <li><a href="#">About</a></li>
                            <li><a href="#">Contact</a></li>
                        </ul>
                    </div>
                    <div>
                        <h4>Categories</h4>
                        <ul>
                            <li><a href="#">Wedding</a></li>
                            <li><a href="#">Engagement</a></li>
                            <li><a href="#">Reception</a></li>
                            <li><a href="#">Haldi</a></li>
                            <li><a href="#">Save the Date</a></li>
                        </ul>
                    </div>
                    <div>
                        <h4>Contact</h4>
                        <ul>
                            <li><i className="fa-solid fa-phone"></i> +91 98765 43210</li>
                            <li><i className="fa-solid fa-envelope"></i> info@weddingwishes.com</li>
                            <li><i className="fa-solid fa-location-dot"></i> Indore, Madhya Pradesh</li>
                        </ul>
                    </div>
                </div>
                <div className="copyright">
                    © 2026 Wedding Wishes. All Rights Reserved.
                </div>
            </footer>
            <button className="back-top">
                <i className="fa-solid fa-arrow-up"></i>
            </button>
        </>
    )
}
export default MainApp;